module.exports = __webpack_public_path__ + "static/media/calendar.4bf7bb88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calendar.svg
// module id = 609
// module chunks = 0